import { NFB_SERVICE, PSY_SERVICE, GENERAL_EEG_SERVICE, FIRST_EEG_SERVICE, FOLLOWUP_SERVICE } from "../../utils/constants";
import { SummaryFieldsConfig } from "./types";

export const PREFERRED_SCHEDULE_SESSIONS_COUNT = 6;

export const BOOKED_STATUSES = ["booked", "confirmed", "awaiting_in_clinic"];

export const DONE_STATUS = "done";

export const SERVICE_TO_SUMMARY_FIELDS: Record<number, SummaryFieldsConfig> = {
    [NFB_SERVICE]: { bookedField: "nfbBooked", doneField: "nfbDone" },
    [PSY_SERVICE]: { bookedField: "psyBooked", doneField: "psyDone" },
    [GENERAL_EEG_SERVICE]: { bookedField: "evaluationsBooked", doneField: "evaluationsDone" },
    [FIRST_EEG_SERVICE]: { bookedField: "evaluationsBooked", doneField: "evaluationsDone" },
    [FOLLOWUP_SERVICE]: { doneField: "followUpDone" },
};

